<template>
  <div class="form-group">
    <label
      v-bind:class="{
        'text-danger': current.errors && current.errors.centro_costo,
      }"
      >{{ titulo }}</label
    >
    <select
      class="form-control"
      autofocus="autofocus"
      required
      v-model="current.centro_costo"
      :disabled="(current.estado = !'A')"
      @input="$emit('input', $event.target.value)"
      @change="$emit('change', $event.target.value)"
    >
      <option v-if="incluir_en_blanco" value="null">Todos</option>
      <option v-for="(d, key) in centros_costos" :value="d.id" :key="key">
        {{ d.id }} -
        {{ d.nombre }}
      </option>
    </select>
    <small
      v-if="current.errors && current.errors.centro_costo"
      class="form-text text-danger"
      >{{ current.errors.centro_costo[0] }}</small
    >
  </div>
</template>
<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    titulo: {
      type: String,
      default: "Centro Costo",
    },
    incluir_en_blanco: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      centros_costos: "",
    };
  },
  computed: {},
  mounted() {
    this.refreshTienda();
  },
  methods: {
    refreshTienda() {
      DynamicService.fetch("cat", "centro-costo").then((response) => {
        this.centros_costos = response.data.results;
      });
    },
  },
};
</script>
